import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

/**
 * Known clickable entity types. A value here must have a matching registration in
 * entity-card/actions/ (see entity-card-action-registry). A card whose entityType is
 * absent or unregistered renders as a static, non-clickable card.
 */
export enum EntityCardEntityType {
  EVENT = 'event',
  PDF = 'pdf',
}

/**
 * Generic, entity-agnostic COMPACT card for a real (non-draft) entity — a thumbnail
 * with a title and a meta line. Reusable across entities (events, social posts,
 * emails, …) to reference something that already exists.
 *
 * When entityType is set to a registered type AND an `entity` payload is present, the
 * card becomes clickable and its onClick is resolved from the entity-card action
 * registry, fed that payload. Missing either renders a static, non-clickable card.
 */
export interface EntityCardProps {
  title?: string;
  meta: string[];
  mediaUrl?: string;
  /** Icon-font class (e.g. 'icon-doc') shown in a brand-tinted box when there is no mediaUrl — used for file/document entities like PDFs. */
  icon?: string;
  entityType?: EntityCardEntityType;
  entity?: Record<string, unknown>;
}

export type EntityCardComponentPart = BaseComponentPart<StreamComponentType.ENTITY_CARD, EntityCardProps>;
